import React from 'react';
import styled from 'styled-components';
import { TextField, Box, Grid, FormControlLabel, Checkbox } from '@material-ui/core';

import { CardTemplateCircleShape, CardTemplateRectangleShape, CardTemplateBalloonShape } from '../redux/cardTemplateShapeDbSlice';
import { CardCircleShape, CardRectangleShape, CardBalloonShape } from '../redux/cardShapeDbSlice';
import { deepCopy } from '../general';
import ColorPalette from './ColorPalette';

const NumberField = styled(TextField)`
  width: 40%;
  margin-right: 3px;
`

const isBalloon = (obj: any): obj is CardTemplateBalloonShape | CardBalloonShape => {
  return obj?.kind === 'balloon';
}

type EditShapeProps = {
  shape: CardTemplateCircleShape | CardTemplateRectangleShape | CardTemplateBalloonShape | CardCircleShape | CardRectangleShape | CardBalloonShape;
  changeItem: (shape: any) => void;
}
const EditShape: React.FC<EditShapeProps> = ({shape, changeItem}) => {
  const strokeWidthMax = isBalloon(shape) ? 8 : 100;
  const changeStrokeDisplay = (display: boolean) => {
    const newItem = deepCopy(shape);
    newItem.stroke.display = display;
    changeItem(newItem);
  }
  const changeFillDisplay = (display: boolean) => {
    const newItem = deepCopy(shape);
    newItem.fill.display = display;
    changeItem(newItem);
  }
  const shapeUpdate = (key: string, value: number, min: number, max: number) => {
    let newValue = value;
    if (newValue < min) newValue = min;
    else if (newValue > max) newValue = max;
    const newItem = deepCopy(shape);
    switch (key) {
      case 'strokeOpacity': newItem.stroke.opacity = newValue; break;
      case 'strokeWidth': newItem.stroke.width = newValue; break;
      case 'fillOpacity': newItem.fill.opacity = newValue; break;
    }
    changeItem(newItem);
  }
  const changeStrokeColor = (value: string) => {
    const newItem = deepCopy(shape);
    newItem.stroke.color = value;
    changeItem(newItem);
  }
  const changeFillColor = (value: string) => {
    const newItem = deepCopy(shape);
    newItem.fill.color = value;
    changeItem(newItem);
  }

  return (
    <Box>
      枠線
      <Box>
        <Grid container alignItems="center">
          <FormControlLabel label="表示"
            control={
              <Checkbox checked={shape.stroke.display} color="primary"
                onChange={(ev) => changeStrokeDisplay(ev.currentTarget.checked)} />
            } />
          <ColorPalette
            currentValue={shape.stroke.color}
            onChange={changeStrokeColor}
            disabled={!shape.stroke.display}
          />
        </Grid>
      </Box>
      <Box mt={1} mb={2}>
        <NumberField variant='outlined' label='透明度'
          type="number" inputProps={{min: 0, max: 1, step: 0.1}}
          value={shape.stroke.opacity}
          onChange={(ev) => shapeUpdate('strokeOpacity', Number(ev.target.value), 0, 1)}
        />
        <NumberField variant='outlined' label='太さ'
          type="number" inputProps={{min: 0, max: strokeWidthMax, step: 1}}
          value={shape.stroke.width}
          onChange={(ev) => shapeUpdate('strokeWidth', Number(ev.target.value), 0, strokeWidthMax)}
        />
      </Box>
      塗りつぶし
      <Box mt={1}>
        <Grid container alignItems="center">
          <FormControlLabel label="表示"
            control={
              <Checkbox checked={shape.fill.display} color="primary"
                onChange={(ev) => changeFillDisplay(ev.currentTarget.checked)} />
            } />
          <ColorPalette
            currentValue={shape.fill.color}
            onChange={changeFillColor}
            disabled={!shape.fill.display}
          />
        </Grid>
      </Box>
      <Box mt={1}>
        <NumberField variant='outlined' label='透明度'
          type="number" inputProps={{min: 0, max: 1, step: 0.1}}
          value={shape.fill.opacity} 
          onChange={(ev) => shapeUpdate('fillOpacity', Number(ev.target.value), 0, 1)}
        />
      </Box>
    </Box>
  );
}

export default EditShape;
